import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SurveyStore } from '@player/shared/services/survey-store.service';

@Component({
  selector: 'brand-name',
  standalone: true,
  templateUrl: './brand-name.component.html',
  styleUrls: ['./brand-name.component.scss'],
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandName {
  readonly ss = inject(SurveyStore);

  @Input()
  @HostBinding('class')
  class: string;

  isEsko = this.ss.branding.value?.name === 'Esko';
}
